var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.filters
    ? _c("div", { staticClass: "products__categories-item" }, [
        _c(
          "a",
          {
            staticClass:
              "products__categories-item-link products-filter__trigger",
            attrs: { href: "javascript:void()" },
            on: {
              click: function($event) {
                $event.preventDefault()
                return _vm.toggleOverlay.apply(null, arguments)
              }
            }
          },
          [
            _c(
              "div",
              { staticClass: "products__categories-item-inner" },
              [
                _vm.filtersActive.length
                  ? _c("span", {
                      staticClass: "products__categories-item-badge",
                      domProps: { innerHTML: _vm._s(_vm.filtersActive.length) }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("SVGFilter", {
                  staticClass: "products__categories-item-icon"
                }),
                _vm._v(" "),
                _c("span", {
                  staticClass:
                    "products__categories-item-text products__categories-item-text--main",
                  domProps: {
                    innerHTML: _vm._s(_vm.$t("shoplist.filter.iconLabel"))
                  }
                })
              ],
              1
            )
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "products-filter" }, [
          _c(
            "div",
            { staticClass: "products-filter__wrapper" },
            [
              _c("div", { staticClass: "products-filter__header" }, [
                _c("h3", {
                  staticClass: "products-filter__title",
                  domProps: {
                    innerHTML: _vm._s(_vm.$t("shoplist.filter.title"))
                  }
                }),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "products-filter__close",
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.closeOverlay.apply(null, arguments)
                      }
                    }
                  },
                  [_c("SVGClose")],
                  1
                )
              ]),
              _vm._v(" "),
              _vm._l(_vm.filtersEnhanced, function(filter) {
                return _c(
                  "div",
                  { key: filter.title, staticClass: "products-filter__group" },
                  [
                    _c("h4", {
                      staticClass: "products-filter__group-title",
                      domProps: { innerHTML: _vm._s(filter.title) }
                    }),
                    _vm._v(" "),
                    _vm._l(filter.options, function(option) {
                      return _c(
                        "label",
                        {
                          key: option.id,
                          staticClass: "products-filter__option"
                        },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.filterStates[option.id],
                                expression: "filterStates[option.id]"
                              }
                            ],
                            staticClass: "products-filter__option-input",
                            attrs: { type: "checkbox" },
                            domProps: {
                              checked: Array.isArray(
                                _vm.filterStates[option.id]
                              )
                                ? _vm._i(_vm.filterStates[option.id], null) > -1
                                : _vm.filterStates[option.id]
                            },
                            on: {
                              change: function($event) {
                                var $$a = _vm.filterStates[option.id],
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      _vm.$set(
                                        _vm.filterStates,
                                        option.id,
                                        $$a.concat([$$v])
                                      )
                                  } else {
                                    $$i > -1 &&
                                      _vm.$set(
                                        _vm.filterStates,
                                        option.id,
                                        $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1))
                                      )
                                  }
                                } else {
                                  _vm.$set(_vm.filterStates, option.id, $$c)
                                }
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("span", {
                            staticClass: "products-filter__option-label",
                            domProps: {
                              innerHTML: _vm._s(option.label || option.id)
                            }
                          })
                        ]
                      )
                    })
                  ],
                  2
                )
              }),
              _vm._v(" "),
              !_vm.filters.length
                ? _c("div", {
                    staticClass: "products-filter__empty",
                    domProps: {
                      innerHTML: _vm._s(_vm.$t("shoplist.filter.empty"))
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.filters.length
                ? _c("Button", {
                    staticClass: "products-filter__apply",
                    attrs: {
                      text: _vm.$t("shoplist.filter.applyButton"),
                      type: "button",
                      level: "primary",
                      block: "",
                      small: "",
                      disabled: _vm.loading
                    },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.onApplyFilters.apply(null, arguments)
                      }
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.hasActiveFilters || _vm.filtersActive.length
                ? _c("Button", {
                    staticClass: "products-filter__reset",
                    attrs: {
                      text: _vm.$t("shoplist.filter.resetButton"),
                      type: "button",
                      level: "tertiary",
                      arrow: "",
                      disabled: _vm.loading
                    },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.onResetFilters.apply(null, arguments)
                      }
                    }
                  })
                : _vm._e()
            ],
            2
          )
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }